import { Reducer } from 'redux';
import { PlanState, PlanTypes } from './types';

const INITIAL_STATE: PlanState = {
  isLoading: false,
  hasError: false,
  data: [],
  total: 0,
};

const reducer: Reducer<PlanState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PlanTypes.LOAD_PLAN_LIST_REQUEST:
      return {
        isLoading: true,
        hasError: false,
        data: [],
        total: 0,
      };
    case PlanTypes.LOAD_PLAN_LIST_SUCCESS:
      return {
        isLoading: false,
        hasError: false,
        data: action.payload.data,
        total: action.payload.total,
      };
    case PlanTypes.LOAD_PLAN_LIST_FAILURE:
      return {
        isLoading: false,
        hasError: true,
        data: [],
        total: 0,
      };
    default:
      return state;
  }
};

export default reducer;
